import React, { useMemo } from "react";
import {
  ContentTraverserContextProvider,
  RicosAlignmentContextProvider,
  RicosContextProvider,
  RicosNodeContextProvider,
  RicosViewerContextProvider,
  SpoilerContextProvider,
  VisibleIndentationContextProvider,
  ZIndexContextProvider
} from "./../../ricos-context";
import { ZIndexService } from "./../../ricos-styles";
import styles from "../statics/rich-content-viewer-scss";
import NodeViewDecorators, { decorators } from "./rericos/decorators";
import renderers from "./rericos/renderers";
import { getPluginRenderers } from "./rericos/renderers/plugins";
import SpoilerManager from "./rericos/utils/SpoilerManager";
import RicosNodesRenderer from "./RicosNodesRenderer";
const ContentTraverser = ({
  content,
  context,
  typeMappers,
  nodeViewRenderers,
  nodeViewDecorators,
  SpoilerViewerWrapper,
  addAnchorsPrefix
}) => {
  const { nodes } = content;
  const spoilerManager = new SpoilerManager();
  const allRenderers = useMemo(
    () => ({
      ...renderers,
      ...getPluginRenderers(context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper)
    }),
    []
  );
  const allDecorators = useMemo(() => {
    return NodeViewDecorators.of([...decorators, ...nodeViewDecorators], context);
  }, []);
  const ricosContext = useMemo(() => {
    const { t, locale, isMobile, theme, experiments, languageDir, jsdomMode } = context;
    return {
      t,
      locale,
      localeContent: locale,
      isMobile,
      theme,
      experiments,
      languageDir,
      jsdomMode,
      tabIndex: 0
    };
  }, [
    context.t,
    context.locale,
    context.isMobile,
    context.theme,
    context.experiments,
    context.languageDir,
    context.jsdomMode
  ]);
  const zIndexService = useMemo(() => {
    return new ZIndexService(context.isMobile, context.theme.settingsStyles);
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RicosContextProvider, { ...ricosContext }, /* @__PURE__ */ React.createElement(ZIndexContextProvider, { zIndexService }, /* @__PURE__ */ React.createElement(
    ContentTraverserContextProvider,
    {
      nodeViewDecorators: allDecorators,
      renderers: allRenderers,
      SpoilerViewerWrapper
    },
    /* @__PURE__ */ React.createElement(RicosViewerContextProvider, { contextualData: context }, /* @__PURE__ */ React.createElement(RicosAlignmentContextProvider, { textAlignment: context.textAlignment }, /* @__PURE__ */ React.createElement(SpoilerContextProvider, { spoilerManager }, /* @__PURE__ */ React.createElement(VisibleIndentationContextProvider, { visibleIndentation: null }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: null, parentIndex: 0 }, /* @__PURE__ */ React.createElement("div", { className: styles.rootedTraversedContent }, /* @__PURE__ */ React.createElement(
      RicosNodesRenderer,
      {
        nodes: nodes ?? [],
        isRoot: true,
        addAnchorsPrefix,
        shouldParagraphApplyTextStyle: true
      }
    )))))))
  ))));
};
var ContentTraverser_default = ContentTraverser;
export {
  ContentTraverser_default as default
};
//# sourceMappingURL=ContentTraverser.js.map
